<template>
  <b-container
    fluid
    class="auth-v2"
  >
    <b-row class="auth-inner m-0">
      <b-col
        class="ml-sm-auto ml-md-auto mx-auto p-0 usersignin-tabs"
        sm="10"
        md="8"
        lg="5"
      >
        <b-nav
          tabs
          justified
          class="m-0"
        >
          <b-nav-item active>
            Log In
          </b-nav-item>
          <!-- <b-nav-item :href="urlPrefix + 'signup'">
            Sign Up For Free
          </b-nav-item> -->
        </b-nav>
      </b-col>
    </b-row>

    <b-row class="auth-inner m-0">
      <b-col
        class="ml-sm-auto ml-md-auto mx-auto login-center"
        sm="10"
        md="8"
        lg="5"
      >
        <div align="center">
          <!-- <b-link :href="urlPrefix"> -->
          <b-img
            width="230px"
            src="https://easyparcel-static.s3.ap-southeast-1.amazonaws.com/Public/source/general/img/menu-logo/easyparcel_logo@2.png"
          />
          <!-- </b-link> -->
        </div>
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form @submit.prevent="login">

            <h2 align="center">
              Welcome Back
            </h2>

            <p align="center">
              Access your account and manage your bookings.
            </p>

            <b-form-group label-for="login-email">
              <validation-provider
                #default="{ errors }"
                name="Email"
                vid="email"
                rules="required|email"
              >
                <b-form-input
                  id="login-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false:null"
                  name="login-email"
                  placeholder="Email Address"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="login-password"
                    v-model="password"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="login-password"
                    placeholder="Password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- <b-form-group>
              <div class="d-flex justify-content-between">
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
                <b-link>
                  <small>Forgot Password?</small>
                </b-link>
              </div>
            </b-form-group> -->

            <b-form-group>
              <b-button
                type="submit"
                block
                :disabled="invalid"
                variant="primary"
              >
                Login
              </b-button>
            </b-form-group>

          </b-form>
        </validation-observer>
        <hr>

        <!-- <b-row>
          <b-col>
            <b-form-group>
              <b-button
                type="button"
                block
                class="btn-facebook"
              >
                Facebook
              </b-button>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <b-button
                type="button"
                block
                class="btn-google"
              >
                Google
              </b-button>
            </b-form-group>
          </b-col>
        </b-row> -->

        <!-- <hr>
        <p align="center">
          Don't have an account?
          <b-link :href="urlPrefix + 'signup'">
            <b>Sign Up</b>
          </b-link>
        </p> -->

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BContainer, BRow, BCol, BNav, BNavItem, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BImg, BForm, BButton, VBTooltip,
  // BContainer, BRow, BCol, BNav, BNavItem, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BImg, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
// import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BContainer,
    BRow,
    BCol,
    BNav,
    BNavItem,
    // BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    // BFormCheckbox,
    // BCardText,
    // BCardTitle,
    BImg,
    BForm,
    BButton,
    // BAlert,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    // const lang = Cookies.get('EP_LANGUAGE')
    // const country = Cookies.get('EP_COUNTRY')
    // const lang = 'en'
    // const country = 'my'
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // urlPrefix: `/${country}/${lang}/`,

      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeOffIcon' : 'EyeIcon'
    },
    // imgUrl() {
    //   if (store.state.appConfig.layout.skin === 'dark') {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
    //     return this.sideImg
    //   }
    //   return this.sideImg
    // },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
          })
            .then(response => {
              console.log('-- response --')
              console.log('-- end response --')

              const { userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Welcome ${userData.fullName || userData.username}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                    },
                  })
                })
            })
            .catch(error => {
              console.log(error.response)
              this.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

body {
  background-color: #f2f4f8;
}
.usersignin-tabs {
  margin-top: 1.42857em;
}
.usersignin-tabs .nav-tabs .nav-link.active {
    background-color: #fff;
    color: #f9278e;
    font-weight: 800;
}
.nav-tabs .nav-link:after {
    left: 0;
    background: #fff !important;
}
.login-center {
  padding: 1.42857em 4.28571em;
  background: #fff;
  margin-bottom: 1.42857em;
  border-radius: 5px;
}
.form-group {
  margin: 1rem;
}
a {
  color: #f9278e;
}

.dark-layout {
  .login-center {
    background-color: #283046;
  }
  .nav-tabs .nav-link:after {
    left: 0;
    background: #283046 !important;
  }
}
</style>
